module.exports = __webpack_public_path__ + "static/turtle-creek-house30-12edade83cfacdbc9b8b2ffcb9084f48.jpg";